import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellTypes, TableDefinition } from '~/Components/DataTable/DataTable.types';

import { MerchantStatus } from '~/Models/DTO/Merchant.models';
import { addressFormatter } from '~/Screens/Settings/ProviderLocations/addressFormatter';
import { StatusTag } from '~/UIKit';
import { MissingInfoButton } from './MissingInfoButton';

type StatusTagFormatterProps = {
  status?: MerchantStatus;
};

export const merchantStatusType = {
  [MerchantStatus.billable]: 'success',
  [MerchantStatus.notBillable]: 'warning',
};

export const MerchantStatusTag = ({ status }: StatusTagFormatterProps) => {
  const { t } = useTranslation();

  if (!status) {
    return <MissingInfoButton />;
  }

  return (
    <StatusTag status={merchantStatusType[status]}>
      {t(`organisation.merchant.status.${MerchantStatus[status]}`)}
    </StatusTag>
  );
};

export const useOrgMerchantListDesktopTableDefinition = (): TableDefinition => {
  const { t } = useTranslation();
  const businessTypes = {
    personal: t('forms.legal.option.entities.individual'),
    legal: t('forms.legal.option.entities.legal'),
  } as any;
  return {
    config: { useSelectableRows: true },
    columns: [
      {
        label: t('forms.legal.fields.label.name'),
        propertyIds: 'name',
        cellType: CellTypes.String,
      },
      {
        label: t('forms.legal.fields.label.address'),
        propertyIds: ['address', 'city', 'zipCode'],
        cellType: CellTypes.String,
        formatter: ({ city, zipCode, address }) => (
          <div>{addressFormatter({ city, street: address, zipCode })}</div>
        ),
      },
      {
        label: t('forms.legal.fields.label.entities'),
        propertyIds: 'entities',
        cellType: CellTypes.String,
        formatter: (entities) => businessTypes?.[entities] ?? entities,
      },
      {
        label: t('forms.legal.fields.label.merchantId'),
        propertyIds: 'merchantId',
        cellType: CellTypes.String,
      },
      {
        label: t('table.column.status'),
        propertyIds: 'status',
        cellType: CellTypes.String,
        formatter: (status) => <MerchantStatusTag status={status} />,
      },
    ],
  };
};
